var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_1889)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#paint0_linear_1101_1889)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 46,
    r: 35,
    fill: "url(#paint1_radial_1101_1889)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29,
    y: 2.65234,
    width: 54.716,
    height: 81.7202,
    transform: "rotate(-50.4948 -29 2.65234)",
    fill: "url(#paint2_radial_1101_1889)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17.6523,
    width: 44.9128,
    height: 41.979,
    transform: "rotate(-50.4948 13 17.6523)",
    fill: "url(#paint3_radial_1101_1889)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1101_1889)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9848 26.3774V39.5898H23.0155V26.3771L13.6728 35.7199L12.2803 34.3274L21.6231 24.9846H8.41036V23.0154H21.6228L12.28 13.6727L13.6725 12.2802L23.0155 21.6233V8.41031H24.9848V21.623L34.3275 12.2802L35.72 13.6727L26.3772 23.0154H39.5898V24.9846H26.3769L35.7197 34.3274L34.3273 35.7199L24.9848 26.3774Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_1889",
    x1: 0,
    y1: 48,
    x2: 48,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE72F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE72F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1101_1889",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42 46) rotate(90) scale(35)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B103",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B103",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1101_1889",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.64198 43.5124) rotate(90) scale(40.8601 27.358)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68511",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1101_1889",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4564 38.6418) rotate(90) scale(20.9895 22.4564)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D904",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_1889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1101_1889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 40 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccountIcon);
export default __webpack_public_path__ + "static/media/AddAccountIcon.f11b0099e73797c87d323f37d090036c.svg";
export { ForwardRef as ReactComponent };